<script setup>
import { onMounted, onUpdated, ref } from 'vue'
import { Inertia } from '@inertiajs/inertia'
import { Link } from '@inertiajs/inertia-vue3'
import ButtonClose from '@/Shared/Buttons/ButtonClose'
import Logo from '@/Shared/Icons/Logo'
import NaviUl from './Navi1Ul'
import NaviJson from './_navi.json'

const json = NaviJson
const lv2Info = ref({})
const submenuOpen = ref(false)
const containerRef = ref()
const menuRef = ref()
const transition1 = ref()
const transition2 = ref()

const emit = defineEmits(['close'])

const closeNav = () => {
  closeSubMenu()
  emit('close')
}

const openSubMenu = (str) => {
  lv2Info.value = json.items.find((item) => item.name === str).lv2
  transition1.value = 'slide-right2'
  transition2.value = 'slide-left2'
  submenuOpen.value = true
  setHeight()
}

const closeSubMenu = (direction) => {
  if (direction === 'back') {
    transition1.value = 'slide-right2'
    transition2.value = 'slide-left2'
  } else {
    transition1.value = 'navi-close1'
    transition2.value = 'navi-close2'
  }
  submenuOpen.value = false
}

const setHeight = () => {
  const menuH = menuRef.value.clientHeight
  if (menuH === 0) return
  const containerH = containerRef.value.clientHeight
  menuRef.value.style.height = `${menuH}px`
  menuRef.value.style.maxHeight = `calc(100dvh - ${containerH - menuH}px)`
}

onMounted(() => {
  Inertia.on('start', () => {
    closeNav()
  })
  setHeight()

  Inertia.on("navigate", (event) => {
    gtag("js", new Date());
    gtag("config", "G-PC5DVSMHQ8");
    gtag('event', 'page_view', {
      'page_location': event.detail.page.url
    })
    dataLayer.push({
      'url': event.detail.page.url,
      'event': 'pageview'
    })
  })

})
onUpdated(() => {
  setHeight()
})
</script>

<template>
  <div class="navi fixed w-full sm:w-[320px] h-[100dvh] top-0 left-0 bg-black text-white overflow-hidden grid place-items-center xl:!flex">
    <ButtonClose class="fixed z-50 white p-[20px] md:p-[25px] top-0 left-0 scale-[1.3] md:scale-[1.5] origin-top-left xl:hidden" @click="closeNav" />
    <div ref="containerRef" class="max-w-[450px] w-full">
      <Link href="/" class="block py-[40px] px-[10vw] xs:px-[40px] 2xl:px-[50px] md:pt-[70px] lg:pt-[40px] bg-black z-60">
        <Logo class="w-full h-auto" type="white1" />
      </Link>

      <div ref="menuRef" class="relative mx-[10vw] xs:mx-[40px] 2xl:mx-[50px] border-dotted border-t-white border-t sm:border-none overflow-x-hidden">
        <transition :name="transition1"><NaviUl v-show="!submenuOpen" type="main" :info="json.items" :fn="openSubMenu" /></transition>
        <transition :name="transition2"><NaviUl v-show="submenuOpen" class="absolute top-0" type="sub" :info="lv2Info" @close="closeSubMenu('back')" /></transition>
      </div>
    </div>
  </div>
</template>
